import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { SNIPPETS } from "./actionTypes";

const INIT_STATE = {
  listaSnippet: {
    totalRecords: 0,
    records: [],
  },
  loadingSnippet: true,
  filterSnippet: null,
  snippet: null,
  messageSnippet: null,
  isSnippetSave: null,

  snippetIdDuplicate: null,
  errorSnippetDuplicate: null,

  snippetProducts: null,
  loadingProducts: true,
  errorProducts: null,

  snippetSections: null,
  loadingSections: true,
  errorSections: null,

  errorLoadingSnippet: null,
  errorLoadingSnippetHistory: null,

  snippetPreview: null,
  errorSnippetPreview: null,

  pageSizeSnippet: DEFAULT_PAGE_SIZE,

  snippetsList: null,
  errorSnippetsList: null,
};

const SnippetsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SNIPPETS.GET_LIST_SNIPPET.REQUEST:
      return {
        ...state,
        filterSnippet: action.payload,
        loadingSnippet: true,
      };
    case SNIPPETS.GET_LIST_SNIPPET.SUCCESS:
      return {
        ...state,
        listaSnippet: action.payload,
        loadingSnippet: false,
      };
    case SNIPPETS.GET_LIST_SNIPPET.FAIL:
      return {
        ...state,
        messageSnippet: action.payload,
        loadingSnippet: false,
      };

    case SNIPPETS.GET_SNIPPET.REQUEST:
      return {
        ...state,
        loadingSnippet: true,
      };
    case SNIPPETS.GET_SNIPPET.SUCCESS:
      return {
        ...state,
        snippet: action.payload,
        loadingSnippet: false,
      };
    case SNIPPETS.GET_SNIPPET.FAIL:
      return {
        ...state,
        messageSnippet: action.payload,
        loadingSnippet: false,
        errorLoadingSnippet: true,
      };

    case SNIPPETS.SAVE_SNIPPET.REQUEST:
      return {
        ...state,
        loadingSnippet: true,
      };
    case SNIPPETS.SAVE_SNIPPET.SUCCESS:
      return {
        ...state,
        isSnippetSave: action.payload,
        loadingSnippet: false,
      };
    case SNIPPETS.SAVE_SNIPPET.FAIL:
      return {
        ...state,
        loadingSnippet: false,
        isSnippetSave: false,
        messageSnippet: action.payload,
      };

    case SNIPPETS.DUPLICATE_SNIPPET.REQUEST:
      return {
        ...state,
        loadingSnippet: true,
      };
    case SNIPPETS.DUPLICATE_SNIPPET.SUCCESS:
      return {
        ...state,
        snippetIdDuplicate: action.payload,
        loadingSnippet: false,
      };
    case SNIPPETS.DUPLICATE_SNIPPET.FAIL:
      return {
        ...state,
        snippetIdDuplicate: false,
        errorSnippetDuplicate: action.payload,
        loadingSnippet: false,
      };

    case SNIPPETS.GET_SNIPPET_HISTORY_LIST.REQUEST:
      return {
        ...state,
        loadingSnippetHistory: true,
      };
    case SNIPPETS.GET_SNIPPET_HISTORY_LIST.SUCCESS:
      return {
        ...state,
        listaSnippetHistory: action.payload,
        loadingSnippetHistory: false,
      };
    case SNIPPETS.GET_SNIPPET_HISTORY_LIST.FAIL:
      return {
        ...state,
        loadingSnippetHistory: false,
        errorLoadingSnippetHistory: true,
      };
    case SNIPPETS.GET_SNIPPET_HISTORY.REQUEST:
      return {
        ...state,
        loadingSnippet: true,
      };
    case SNIPPETS.GET_SNIPPET_HISTORY.SUCCESS:
      return {
        ...state,
        snippet: action.payload,
        loadingSnippet: false,
      };
    case SNIPPETS.GET_SNIPPET_HISTORY.FAIL:
      return {
        ...state,
        loadingSnippet: false,
        messageSnippet: action.payload,
        errorLoadingSnippetHistory: true,
      };

    case SNIPPETS.GET_SNIPPET_PRODUCTS.REQUEST:
      return {
        ...state,
        loadingProducts: true,
      };
    case SNIPPETS.GET_SNIPPET_PRODUCTS.SUCCESS:
      return {
        ...state,
        snippetProducts: action.payload,
        loadingProducts: false,
      };
    case SNIPPETS.GET_SNIPPET_PRODUCTS.FAIL:
      return {
        ...state,
        loadingProducts: false,
        errorProducts: action.payload,
      };

    case SNIPPETS.GET_SNIPPET_SECTIONS.REQUEST:
      return {
        ...state,
        loadingSections: true,
      };
    case SNIPPETS.GET_SNIPPET_SECTIONS.SUCCESS:
      return {
        ...state,
        snippetSections: action.payload,
        loadingSections: false,
      };
    case SNIPPETS.GET_SNIPPET_SECTIONS.FAIL:
      return {
        ...state,
        loadingSections: false,
        errorSections: action.payload,
      };

    case SNIPPETS.GET_SNIPPET_PREVIEW.REQUEST:
      return {
        ...state,
        loadingSnippet: true,
      };
    case SNIPPETS.GET_SNIPPET_PREVIEW.SUCCESS:
      return {
        ...state,
        snippetPreview: action.payload,
        loadingSnippet: false,
      };
    case SNIPPETS.GET_SNIPPET_PREVIEW.FAIL:
      return {
        ...state,
        loadingSnippet: false,
        snippetPreview: false,
        errorSnippetPreview: action.payload,
      };

    case SNIPPETS.LOAD_EMPTY:
      return {
        ...state,
        snippet: null,
        loadingSnippet: false,
        snippetPreview: null,
        snippetIdDuplicate: null,
        errorLoadingSnippet: null,
        errorLoadingSnippetHistory: null,
        errorSnippetPreview: null,
        errorSnippetDuplicate: null,
      };
    case SNIPPETS.CLEAN_MESSAGE:
      return {
        ...state,
        messageSnippet: null,
        loadingSnippet: false,
        isSnippetSave: null,
        snippetsList: null,
        errorSnippetsList: null,
      };
    case SNIPPETS.CLEAN_ID_SNIPPET_DUPLICATE:
      return {
        ...state,
        snippetIdDuplicate: null,
        loadingSnippet: false,
      };
    case SNIPPETS.CHANGE_PAGE_SIZE_SNIPPET:
      return {
        ...state,
        pageSizeSnippet: action.payload,
      };

    case SNIPPETS.POST_SNIPPET_DOWNLOAD_LIST.REQUEST:
      return {
        ...state,
        loadingSnippet: true,
      }
    case SNIPPETS.POST_SNIPPET_DOWNLOAD_LIST.SUCCESS:
      return {
        ...state,
        snippetsList: action.payload,
        loadingSnippet: false,
      }
    case SNIPPETS.POST_SNIPPET_DOWNLOAD_LIST.FAIL:
      return {
        ...state,
        loadingSnippet: false,
        snippetsList: null,
        errorSnippetsList: action.payload,
      };

    default:
      return state;
  }
};

export default SnippetsReducer;
